module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/sales-2dfd0b2df319d72b35cfc68748e172f6.svg";